<h1 mat-dialog-title>Product Tiles Categories for {{data.companyName}}</h1>
<div mat-dialog-content>
  <div class="setting-mode-panel">
    <div class="setting-mode-buttons">
      @if (canInherit()) {
        <button
          mat-stroked-button
          type="button"
          [class.active-mode]="mode === 'inherit'"
          (click)="setMode('inherit')">
          Use Parent Setting
        </button>
      }
      <button
        mat-stroked-button
        type="button"
        [class.active-mode]="mode === 'none'"
        (click)="setMode('none')">
        No Categories For This Company
      </button>
      <button
        mat-stroked-button
        type="button"
        [class.active-mode]="mode === 'custom'"
        (click)="setMode('custom')">
        Set Custom Categories
      </button>
    </div>
    @if (mode === 'inherit' && canInherit()) {
      <p class="setting-mode-help">
        This company will use Product Tiles Categories from {{data.parentCompanyName || 'its parent company'}}, or fall back to the linked reward defaults when no parent override exists.
      </p>
    }
    @if (mode === 'none') {
      <p class="setting-mode-help">
        This company will explicitly override any inherited setting and have no tile categories for its selected products.
      </p>
    }
    @if (mode === 'custom') {
      <p class="setting-mode-help">
        Set custom band categories for this company. These categories replace the linked reward defaults for matching products.
      </p>
    }
  </div>
  @if (items.length === 0) {
    <app-inlinemessage
      level="warning"
      message="No products selected for this company. Set Products first.">
    </app-inlinemessage>
  }

  @if (items.length > 0) {
    <table class="table" mat-table [dataSource]="items">
      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Product</th>
        <td class="cell" mat-cell *matCellDef="let item">
          {{item.vendorName}} - {{item.productName}}
        </td>
      </ng-container>
      <ng-container matColumnDef="productId">
        <th mat-header-cell *matHeaderCellDef>Product ID</th>
        <td class="cell" mat-cell *matCellDef="let item">
          {{item.id}}
        </td>
      </ng-container>
      <ng-container matColumnDef="categories">
        <th mat-header-cell *matHeaderCellDef>Tile Categories</th>
        <td mat-cell *matCellDef="let item">
          <div class="category-section">
            <div class="category-section-label">Reward Defaults</div>
            <div class="categories-set">
              @for (category of getRewardDefaultCategories(item.id); track category) {
                <div class="category-chip default-chip">
                  <span class="category-chip-label">{{category}}</span>
                </div>
              }
              @if (getRewardDefaultCategories(item.id).length === 0) {
                <span class="empty-category-state">
                  No linked reward default categories
                </span>
              }
            </div>
          </div>
          <div class="category-section">
            <div class="category-section-label">Company Setting</div>
            <div class="categories-set">
              @for (category of getCategories(item.id); track category) {
                <div class="category-chip">
                  <span class="category-chip-label">{{category}}</span>
                  <button class="remove-chip-button" mat-icon-button type="button" [disabled]="!isCustomMode()" (click)="removeCategory(item.id, category); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
              @if (getCategories(item.id).length === 0 && mode === 'inherit') {
                <span class="empty-category-state">
                  No inherited company override
                </span>
              }
              @if (getCategories(item.id).length === 0 && mode === 'none') {
                <span class="empty-category-state">
                  No tile categories for this company
                </span>
              }
              @if (getCategories(item.id).length === 0 && mode === 'custom') {
                <span class="empty-category-state">
                  No custom company override
                </span>
              }
            </div>
          </div>
          <div class="category-input-row">
            <input
              class="category-input"
              matInput
              placeholder="Add company override category"
              [value]="draftCategoryByProductId[item.id] || ''"
              [disabled]="!isCustomMode()"
              (input)="onDraftCategoryChange(item.id, $any($event.target).value)"
              (keydown.enter)="addDraftCategory(item.id); $event.preventDefault()"
              />
            <button class="add-category-button" mat-stroked-button color="primary" type="button" [disabled]="!isCustomMode()" (click)="addDraftCategory(item.id)">Add</button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['product', 'productId', 'categories']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['product', 'productId', 'categories']"></tr>
    </table>
  }
</div>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button class="donebutton" color="primary" (click)="okClicked()">Done</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
